// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1mqi8","list":"BalanceDue_list__37Fmc","listRow":"BalanceDue_listRow__1jOJW","total":"BalanceDue_total__2z8lR"};